// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class DomainEvent<T> {
    constructor(public key: string) {}
}
